import React, { FunctionComponent, SVGProps, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import Dots from '@/assets/img/dots-3.svg';
import './FilterMenu.scss';
import ActionIcon from '@/assets/rewise/action-btn.svg';
import Delete from '@/assets/steam/delete.svg';
import { default as ReactSelect, components } from 'react-select';
import FilterIcon from '@/assets/steam/filter.svg';

import Checkmark from '@/assets/steam/green-check.png';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import { City, State, UserRole } from '@/features/users/types/indes';
import { useGetCityList } from '@/features/users/api/getRefrences';

export type ActionMenu = {
  label: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  onClickHandler: (params: any) => any;
  itemClassName: string;
};

type ActionMenuProps = {
  options: ActionMenu[];
  isDropdown?: boolean;
  isVerticalIcon?: boolean;
  roles?: any;
  states?: any;
  onRoleSelect: (filter: any) => void;
  showRoleFilter?: boolean;

};

export const FilterMenu = ({ options, isDropdown = true, isVerticalIcon, roles, states, onRoleSelect, showRoleFilter = true }: ActionMenuProps) => {
  const [selectedRole, setSelectedRole] = useState<any[]>()
  const [cities, setCities] = useState<any[]>()
  const [selectedState, setSelectedState] = useState<State[]>();
  const [selectedCity, setSelectedCity] = useState<City[]>();
  const useGetCityMutation = useGetCityList();
  const [stateSelected, setStateSelected] = useState<any>();

  const getCityList = async (id: any) => {
    const res = await useGetCityMutation.mutateAsync({ id });
    if (res) {
      setCities(res.list);
    }
  };

  useEffect(() => {
    if (selectedRole || selectedState || selectedCity ) {
      applyFilter();
    }
  }, [selectedRole,  selectedState , selectedCity ]);

  const clearFilter = () => {
    setSelectedState([]);
    setStateSelected('');
    setSelectedRole([]);
    setCities([]);
    setSelectedCity([]);
    onRoleSelect(null)
  }

  const applyFilter = () => {
    const rolesIds = selectedRole && selectedRole.length > 0 ? selectedRole.map((item: any) => Number(item.id)) : [];
    const stateIds = states && states.length > 0
      ? states
        .filter((item: any) => item.name === stateSelected)
        .map((item: any) => Number(item.id))
      : [];

    const cityIds = selectedCity && selectedCity.length > 0
      ? selectedCity.map((item: any) => Number(item.id))
      : [];
    onRoleSelect({ 'rolesId': rolesIds, 'stateId': stateIds, "cityId" : cityIds } )
  }

  const isShowfilerCheck = () =>{
    if(selectedRole && selectedRole.length > 0){
      return true
    }else if(selectedCity && selectedCity.length > 0){
      return true
    }else if (stateSelected){
      return true
    }else{
      return false
    }
  }
  return (
    <>
      <Dropdown className={`filter-menu dot-3-btn ${isVerticalIcon ? 'is-vertical-icon' : ''}`}>
        <Dropdown.Toggle id="dropdown-basic" className="dots-3-icon">
          <img src={isVerticalIcon ? FilterIcon : FilterIcon} className="filter-icon" />
         {isShowfilerCheck() &&  <img src={Checkmark} className='green-checkmark'/>}
        </Dropdown.Toggle>
        <Dropdown.Menu className="drop-down-backdrop">
          <div className="action-no-dropdown add-display">
            {/* <Dropdown className="new-figma-drop-down">
              <Dropdown.Toggle
                variant="success"
                className="drop-down-btn fixed-width-filter dropdown-toggle"
                id="dropdown-basic"
              >
                {selectedRole ? selectedRole : 'Select role'}
              </Dropdown.Toggle>
              <Dropdown.Menu className="Duration-drop-down">
                {roles?.map((item: any, index: any) => {
                  return (
                    <Dropdown.Item
                      key={index}
                      onClick={() => {
                        setSelectedRole(item.name)
                      }}
                      eventKey={item.name}
                    >
                      <div className="menu-item-minutes">{item.name}</div>
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown> */}
           {showRoleFilter &&  <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react filter-height filter-fixed-width"
                options={roles ? roles : []}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setSelectedRole(selected);
                 // applyFilter();
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option: Option1,
                  ValueContainer: ValueContainer1,
                }}
                placeholder={'Select role'}
                value={selectedRole}

              />
            </div>}
            {/* <div>
              <Dropdown className="new-figma-drop-down">
                <Dropdown.Toggle
                  variant="success"
                  className="drop-down-btn filter-width filter-fixed-width dropdown-toggle"
                  id="dropdown-basic"
                >
                  {stateSelected ? stateSelected : 'Select state'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="Duration-drop-down">
                  {states?.map((item: any, index: any) => {
                    return (
                      <Dropdown.Item
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation(); 
                          setCities([]);
                          setSelectedCity([]);
                          setStateSelected(item.name)
                          getCityList(item.id);
                        }}
                        eventKey={item.name}
                      >
                        <div className="menu-item-minutes">{item.name}</div>
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div> */}

            {states && states.length > 0 && <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react filter-height filter-fixed-width"
                options={states ? states : []}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  if (selected) {
                    setSelectedState(selected); 
                    setCities([]); 
                    setSelectedCity([]); 
                    setStateSelected(selected.name); 
                    getCityList(selected.id);
                    //applyFilter()
                  }
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                // components={{
                //   Option,
                //   ValueContainer,
                // }}
                placeholder={'Select state'}
                value={selectedState}

              />
            </div>}
            {cities && cities.length > 0 && <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react filter-height filter-fixed-width"
                options={cities ? cities : []}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setSelectedCity(selected);
                  //applyFilter()
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option,
                  ValueContainer,
                }}
                placeholder={'Select city'}
                value={selectedCity}

              />
            </div>}
            {/* <div onClick={() => { applyFilter() }} className='filter-clear-icon mt1-18' >

              <SearchIcon />
            </div> */}
            <div onClick={() => { clearFilter() }}>
              <img src={Delete} className='filter-clear-icon' />
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>

    </>
  );
};

const Option = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select city</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added`}
      {React.Children.map(props.children, (child) => {
        if(child){
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};



const Option1 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer1 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select role</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added`}
      {React.Children.map(props.children, (child) => {
        if(child){

          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};

FilterMenu.displayName = 'FilterMenu';
